import { render, staticRenderFns } from "./SelectTopBarIcon.vue?vue&type=template&id=7074e961&"
import script from "./SelectTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./SelectTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports